const prestacaocontasRoutes = [
  // Boleto
  {
    path: '/prestacaocontas',
    name: 'prestacaocontas',
    component: () => import('@/views/prestacaocontas/PrestacaoContasDashboard.vue'),
    meta: {
      resource: 'Auth',
      action: 'read',
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Prestação de Contas', active: true },
      ],
    },
  },
  {
    path: '/prestacaocontas/view/:id',
    name: 'prestacaocontas',
    component: () => import('@/views/prestacaocontas/PrestacaoContasView.vue'),
    meta: {
      parent: 'prestacaocontas',
      resource: 'Auth',
      action: 'read',
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Assembleias', url: '/prescataocontas' },
        { title: 'Ver', active: true },
      ],
    },
  },
]

export default prestacaocontasRoutes
